import type { SxProps, Theme } from '@mui/material';

export const artifactsFilesListSx: SxProps<Theme> = theme => ({
  display: 'flex',
  flexWrap: 'wrap',
  listStyle: 'none',
  margin: 0,
  padding: 0,
  '.view-single-entry &': {
    marginBottom: '-6px',
  },
  '& > li': {
    display: 'flex',
    borderRadius: '3px',
    border: '1px solid',
    borderColor: 'border.separator',
    margin: '6px 12px 6px 0',
    height: '35px',
    maxWidth: '100%',
    [theme.breakpoints.down('md')]: {
      height: '30px',
      margin: '4px 8px 4px 0',
    },
  },
  '& button': {
    background: 'none',
    cursor: 'pointer',
    padding: 0,
    alignItems: 'center',
    border: 'none',
    display: 'flex',
    textAlign: 'left',
    overflow: 'hidden',
    transition: 'all 0.15s',
    '&[disabled]': {
      opacity: 0.5,
      cursor: 'default',
    },
    '&:first-child': {
      padding: '6px',
      [theme.breakpoints.down('md')]: { padding: '4px' },
      '& img': { fontSize: 0 },
    },
    '&:last-child': {
      borderLeft: '1px solid',
      borderColor: 'border.separator',
      minWidth: '30px',
      justifyContent: 'center',
    },
    '&:hover': { backgroundColor: 'background.default' },
    '&:focus': { outline: 'none' },
  },
  '& span': {
    color: 'text.secondary',
    fontSize: '0.875rem',
  },
  '& img': {
    objectFit: 'cover',
    height: '100%',
    width: '100%',
  },
  '& .files-list__files-icon': {
    height: '30px',
    marginRight: '-6px',
    width: '34px',
    marginLeft: '-8px',
    flex: '1 0 28px',
    minWidth: '34px',
  },
  '& .files-list__files-image': {
    width: '25px',
    height: '22px',
    margin: '0 3px 2px 2px',
    minWidth: '25px',
  },
  '& .files-list__files-name': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    margin: 0,
    maxWidth: '500px',
  },
  '& .files-list__files-type': {
    marginRight: '4px',
    flexShrink: 0,
  },
  '& .files-list__files-download': {
    height: '14px',
    width: '11px',
    [theme.breakpoints.down('md')]: {
      height: '13px',
      width: '10px',
    },
    '& img': {
      marginBottom: '3px',
      verticalAlign: 'baseline',
    },
  },
});

export const artifactsPhotosListSx = {
  padding: 0,
  marginBottom: '-7px',
  '.view-single-entry &': {
    margin: '3px 0 -10px',
  },
  '& > li': {
    display: 'inline-block',
    margin: '0 10px 10px 0',
  },
  '& button': {
    border: '1px solid',
    borderColor: 'border.separator',
    height: '80px',
    width: '80px',
    padding: 0,
    '&:last-child': { display: 'none' },
  },
  '& span': {
    overflow: 'hidden',
    height: '100%',
    width: '100%',
    margin: 0,
    '&:not(:first-child)': { display: 'none' },
  },
  '& img': {
    height: '100%',
    width: '100%',
  },
} as const;
